/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 9527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   L1: function() { return /* binding */ PUB_SUB_EVENTS; },
/* harmony export */   nY: function() { return /* binding */ publish; }
/* harmony export */ });
/* unused harmony exports ON_CHANGE_DEBOUNCE_TIMER, subscribe */
const globalScope = typeof window !== 'undefined' ? window : globalThis;
if (!globalScope.__PUBSUB_SINGLETON__) {
  globalScope.__PUBSUB_SINGLETON__ = {
    subscribers: {}
  };
}
const pubsubID = Math.random().toString(36).substring(2, 6);
const ON_CHANGE_DEBOUNCE_TIMER = 300;
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};
function subscribe(eventName, callback) {
  if (!globalScope.__PUBSUB_SINGLETON__.subscribers[eventName]) {
    globalScope.__PUBSUB_SINGLETON__.subscribers[eventName] = [];
  }
  globalScope.__PUBSUB_SINGLETON__.subscribers[eventName].push(callback);
  return function unsubscribe() {
    const list = globalScope.__PUBSUB_SINGLETON__.subscribers[eventName] || [];
    globalScope.__PUBSUB_SINGLETON__.subscribers[eventName] = list.filter(cb => cb !== callback);
  };
}
function publish(eventName, data) {
  const callbacks = globalScope.__PUBSUB_SINGLETON__.subscribers[eventName] || [];
  callbacks.forEach((callback, index) => {
    try {
      callback(data);
    } catch (e) {
      console.error(`[publish] error in callback[${index}]`, e);
    }
  });
}
if (typeof window !== 'undefined') {
  window.__PUBSUB_SINGLETON__ = globalScope.__PUBSUB_SINGLETON__; // même instance
  window.subscribe ??= subscribe;
  window.publish ??= publish;
  window.PUB_SUB_EVENTS ??= PUB_SUB_EVENTS;
}

/***/ }),

/***/ 4076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Q2: function() { return /* binding */ fetchConfig; }
/* harmony export */ });
/* unused harmony exports pauseAllMedia, debounce, isStorageSupported, checkScrollbar, setScrollbarWidth, setHeaderBottomPosition, getFocusableElements, trapFocus, removeTrapFocus, filterShopifyEvent */
function pauseAllMedia() {
  document.querySelectorAll('iframe.js-youtube').forEach(video => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('iframe.js-vimeo').forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video-section[data-type="youtube"]:not([data-video-hero]) iframe').forEach(video => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('video-section[data-type="vimeo"]:not([data-video-hero]) iframe').forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach(video => {
    if (!video.closest('[data-video-hero]')) video.pause();
  });
  document.querySelectorAll('product-model').forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': `application/${type}`
    }
  };
}
function isStorageSupported(type) {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false;
  }
  const testKey = 'beyours:test';
  let storage;
  if (type === 'session') {
    storage = window.sessionStorage;
  }
  if (type === 'local') {
    storage = window.localStorage;
  }
  try {
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    // Do nothing, this may happen in Safari in incognito mode
    return false;
  }
}
function checkScrollbar() {
  const rect = document.body.getBoundingClientRect();
  return Math.round(rect.left + rect.right) < window.innerWidth;
}
function setScrollbarWidth() {
  if (checkScrollbar()) {
    const element = document.createElement('span');
    element.className = 'modal-scrollbar-measure', document.body.appendChild(element);
    const width = element.getBoundingClientRect().width - element.clientWidth;
    document.body.removeChild(element);
    document.documentElement.style.setProperty('--scrollbar-width', `${width}px`);
  }
}
function setHeaderBottomPosition() {
  const header = document.querySelector('.shopify-section-header');
  if (header) {
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(header.getBoundingClientRect().bottom)}px`);
  }
}
function getFocusableElements(container) {
  return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = event => {
    if (event.target !== container && event.target !== last && event.target !== first) return;
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (event) {
    const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
    if (charCode !== 'TAB') return; // If not TAB key

    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };
  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  if (elementToFocus) elementToFocus.focus();
  if (elementToFocus?.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}
function filterShopifyEvent(event, domElement, callback) {
  let executeCallback = false;
  if (event.type.includes('shopify:section')) {
    if (domElement.hasAttribute('data-section-id') && domElement.getAttribute('data-section-id') === event.detail.sectionId) {
      executeCallback = true;
    }
  } else if (event.type.includes('shopify:block') && event.target === domElement) {
    executeCallback = true;
  }
  if (executeCallback) {
    callback(event);
  }
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
!function() {
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4076);
/* harmony import */ var _pubsub__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9527);


if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.variantIdInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      //this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.cart = document.querySelector('mini-cart');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton.querySelector('span');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      // this.querySelector('.loading__spinner').classList.remove('hidden');

      const config = (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .fetchConfig */ .Q2)('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      const quickViewDrawerDetails = document.querySelector('quick-view-drawer details');
      if (quickViewDrawerDetails) {
        quickViewDrawerDetails.classList.remove('menu-opening');
        quickViewDrawerDetails.removeAttribute('open');
      }
      fetch(`${theme.routes.cart_add_url}`, config).then(response => response.json()).then(response => {
        if (response.status) {
          (0,_pubsub__WEBPACK_IMPORTED_MODULE_1__/* .publish */ .nY)(_pubsub__WEBPACK_IMPORTED_MODULE_1__/* .PUB_SUB_EVENTS */ .L1.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: response.errors || response.description,
            message: response.message
          });
          this.handleErrorMessage(response.description);
          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButtonText.classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = theme.routes.cart_url;
          return;
        }
        if (!this.error) (0,_pubsub__WEBPACK_IMPORTED_MODULE_1__/* .publish */ .nY)(_pubsub__WEBPACK_IMPORTED_MODULE_1__/* .PUB_SUB_EVENTS */ .L1.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: response
        });
        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => {
              this.cart.renderContents(response);
            });
          }, {
            once: true
          });
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }
      }).catch(e => {
        console.error(e);
      }).finally(() => {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        // this.querySelector('.loading__spinner').classList.add('hidden');
      });
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      const wrappers = this.querySelectorAll('.product-form__error-message-wrapper');
      const messages = this.querySelectorAll('.product-form__error-message');
      wrappers.forEach(wrapper => {
        wrapper.toggleAttribute('hidden', !errorMessage);
      });
      if (errorMessage) {
        messages.forEach(msg => {
          msg.textContent = errorMessage;
        });
      }
    }
    toggleSubmitButton(disable = true, text) {
      const submitButtons = this.querySelectorAll('[type="submit"]');
      submitButtons.forEach(button => {
        const buttonText = button.querySelector('span');
        const soldOutMessage = button.querySelector('.sold-out-message');
        if (disable) {
          button.setAttribute('disabled', 'disabled');
          button.setAttribute('aria-disabled', 'true');
          if (buttonText && text) buttonText.textContent = text;
          if (soldOutMessage) {
            buttonText?.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
          }
        } else {
          button.removeAttribute('disabled');
          button.removeAttribute('aria-disabled');
          if (soldOutMessage) {
            buttonText?.classList.remove('hidden');
            soldOutMessage.classList.add('hidden');
          }
        }
      });
    }
    get variantIdInput() {
      return this.form.querySelector('[name=id]');
    }
  });
}
}();
/******/ })()
;